import { render, staticRenderFns } from "./EndpointThreatsTable.vue?vue&type=template&id=06059b02&"
import script from "./EndpointThreatsTable.vue?vue&type=script&lang=js&"
export * from "./EndpointThreatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports